import {
  GET_BUSINESS_UNITS,
  GET_BUSINESS_UNITS_SUCCESS,
  GET_BUSINESS_UNITS_FAIL,
  GET_BUSINESS_UNIT,
  GET_BUSINESS_UNIT_SUCCESS,
  GET_BUSINESS_UNIT_FAIL,
  SHOW_DELETE_MODAL,
  HIDE_DELETE_MODAL,
  DELETE_BUSINESS_UNIT,
  DELETE_BUSINESS_UNIT_SUCCESS,
  DELETE_BUSINESS_UNIT_FAIL,
  CREATE_BUSINESS_UNIT,
  CREATE_BUSINESS_UNIT_SUCCESS,
  CREATE_BUSINESS_UNIT_FAIL,
  UPDATE_BUSINESS_UNIT,
  UPDATE_BUSINESS_UNIT_SUCCESS,
  UPDATE_BUSINESS_UNIT_FAIL,
} from "./actionTypes"
import { API_ERROR } from "../popup/actionTypes"

const INIT_STATE = {
  businessUnits: [],
  businessUnit: null,
  error: "",
  loading: false,
  current_page: 1,
  last_page: 1,
  total_items: 1,
  items_per_page: 25,
  from: 1,
  to: 1,
  isDeleteModalOpen: false,
}

const BusinessUnits = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BUSINESS_UNITS:
      return {
        ...state,
        loading: true,
      }

    case GET_BUSINESS_UNITS_SUCCESS:
      if (action.payload.data) {
        return {
          ...state,
          businessUnits: action.payload.data,
          current_page: action.payload.current_page,
          last_page: action.payload.last_page,
          total_items: action.payload.total,
          items_per_page: action.payload.per_page,
          from: action.payload.from,
          to: action.payload.to,
          loading: false,
        }
      } else {
        return {
          ...state,
          businessUnits: action.payload,
          loading: false,
        }
      }
      break

    case GET_BUSINESS_UNITS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_BUSINESS_UNIT:
      return {
        ...state,
        loading: true,
      }
    case GET_BUSINESS_UNIT_SUCCESS:
      return {
        ...state,
        businessUnit: action.payload,
        loading: false,
      }

    case GET_BUSINESS_UNIT_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case DELETE_BUSINESS_UNIT:
      return {
        ...state,
        loading: true,
      }

    case DELETE_BUSINESS_UNIT_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case DELETE_BUSINESS_UNIT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    case SHOW_DELETE_MODAL:
      return {
        ...state,
        isDeleteModalOpen: true,
      }

    case HIDE_DELETE_MODAL:
      return {
        ...state,
        isDeleteModalOpen: false,
      }

    case CREATE_BUSINESS_UNIT:
      return {
        ...state,
        loading: true,
      }

    case CREATE_BUSINESS_UNIT_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case CREATE_BUSINESS_UNIT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    case UPDATE_BUSINESS_UNIT:
      return {
        ...state,
        loading: true,
      }

    case UPDATE_BUSINESS_UNIT_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case UPDATE_BUSINESS_UNIT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default BusinessUnits
